module.exports = __webpack_public_path__ + "img/popup_economy_pay_head.528ab449.png";